import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { TranslateService } from '@ngx-translate/core';
import { SageSalesService } from './sage-sales.service';

@Component({
  selector: 'app-sage-sales-lines',
  templateUrl: './sage-sales-lines.component.html',
  styleUrls: ['./sage-sales-lines.component.scss']
})
export class SageSalesLinesComponent implements OnInit {
  public organization_id: string;
  public sale: any;
  public salesLines: any[] = [];
  public columns: Array<{ field: string; header: string }> = [];
  public loadingLines:boolean = true;

  constructor(
    private config: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    private sageSalesService: SageSalesService,
    private translateService: TranslateService
  ) { }

  ngOnInit(): void {
    this.organization_id = this.config.data?.organization_id;
    this.sale = this.config.data?.sale;
    console.log("asdf sales lines config data -> ", this.config.data);
    this.loadSaleLines();
  }

  loadSaleLines(): void {
    if (!this.organization_id || !this.sale || !this.sale.IdFacturaCli) {
      return;
    }

    this.sageSalesService.getSageSaleLines(this.organization_id, this.sale.IdFacturaCli).subscribe({
      next: (data: any[]) => {
        this.salesLines = data;
        this.loadingLines = false;
        console.log("asdf sales lines", data);
      },
      error: () => {
        this.salesLines = [];
        this.loadingLines = false;
      }
    });
  }

  close(): void {
    this.dynamicDialogRef.close();
  }
}
